import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "./Icon";
import { Text } from "./Text";
import { View } from "./View";
import { useTheme } from "../styles";
/**
 * {@adf 💾̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̅̃̀̀̆̉̀̀̆̎̀̀̆̇̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̆̌̀̀̆́̀̀̇̉̀̀̆̏̀̀̇̅̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆́̀̀̆̌̀̀̆̉̀̀̆̇̀̀̆̎̀̀̂̍̀̀̇̃̀̀̇̄̀̀̆́̀̀̇̂̀̀̇̄̀̀̂̂̀̀̇̍̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̎̀̀̇̄̀̀̆̅̀̀̆̎̀̀̇̄̀̀̂̂̀̀̃̊̀̀̅̋̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̍̀̀̆̅̀̀̆̄̀̀̆̉̀̀̆́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̇̄̀̀̇̄̀̀̇̂̀̀̇̃̀̀̂̂̀̀̃̊̀̀̇̋̀̀̂̂̀̀̇̄̀̀̇̉̀̀̇̀̀̀̆̅̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̆̀̀̆̉̀̀̆̌̀̀̆̅̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̉̀̀̆̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̄̀̀̃̂̀̀̆̃̀̀̃̄̀̀̃̆̀̀̃̂̀̀̆̂̀̀̆́̀̀̂̍̀̀̆̂̀̀̃̈̀̀̃̄̀̀̆́̀̀̂̍̀̀̃̄̀̀̃̇̀̀̃̅̀̀̆̆̀̀̂̍̀̀̃̉̀̀̆́̀̀̆̆̀̀̃̆̀̀̂̍̀̀̆̅̀̀̃̅̀̀̃̉̀̀̃̂̀̀̃̃̀̀̆̃̀̀̆̆̀̀̆́̀̀̃̉̀̀̃̈̀̀̃̅̀̀̃́̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆́̀̀̆̌̀̀̇̄̀̀̂̂̀̀̃̊̀̀̂̂̀̀̆̉̀̀̆̍̀̀̆́̀̀̆̇̀̀̆̅̀̀̂̍̀̀̃̂̀̀̃̀̀̀̃̂̀̀̃̄̀̀̃̀̀̀̃̉̀̀̃́̀̀̃̃̀̀̂̍̀̀̃́̀̀̃̆̀̀̃̂̀̀̃̄̀̀̃̃̀̀̃̃̀̀̂̎̀̀̇̀̀̀̆̎̀̀̆̇̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̃̀̀̆̏̀̀̆̌̀̀̆̌̀̀̆̅̀̀̆̃̀̀̇̄̀̀̆̉̀̀̆̏̀̀̆̎̀̀̂̂̀̀̃̊̀̀̂̂̀̀̂̂̀̀̂̌̀̀̂̂̀̀̆̈̀̀̆̅̀̀̆̉̀̀̆̇̀̀̆̈̀̀̇̄̀̀̂̂̀̀̃̊̀̀̃́̀̀̃̂̀̀̃̅̀̀̂̌̀̀̂̂̀̀̇̇̀̀̆̉̀̀̆̄̀̀̇̄̀̀̆̈̀̀̂̂̀̀̃̊̀̀̃̆̀̀̃̂̀̀̃̅̀̀̇̍̀̀̇̍̀̀̅̍̀̀̇̍}
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-16}
 */ export function Pill(param) {
    var _param_color = param.color, color = _param_color === void 0 ? '#69826F' : _param_color, _param_backgroundColor = param.backgroundColor, backgroundColor = _param_backgroundColor === void 0 ? 'white' : _param_backgroundColor, icon = param.icon, text = param.text, _param_size = param.size, size = _param_size === void 0 ? 'small' : _param_size, onClose = param.onClose;
    var theme = useTheme().theme;
    return /*#__PURE__*/ _jsxs(View, {
        style: {
            backgroundColor: backgroundColor,
            borderRadius: 30,
            paddingHorizontal: 10,
            paddingVertical: 5,
            justifyContent: 'center'
        },
        row: true,
        children: [
            icon ? /*#__PURE__*/ _jsx(Icon, {
                size: 12,
                name: icon,
                color: color,
                style: {
                    marginRight: 5
                }
            }) : null,
            /*#__PURE__*/ _jsx(Text, {
                text: text,
                size: size === 'small' ? 13 : 15,
                color: color,
                weight: "semibold"
            }),
            onClose ? /*#__PURE__*/ _jsx(Icon, {
                size: 10,
                name: "close",
                onPress: onClose,
                "aria-label": "Close",
                color: theme.color.gray400,
                style: {
                    marginLeft: 10
                }
            }) : null
        ]
    });
}
